import React from "react";
import Grid from "@mui/material/Grid2";
import styles from "./LandingPage.module.css";
import { Box, Button, Typography } from "@mui/material";
import { Logo } from "./assets/SvgImage";
import { useNavigate } from "react-router-dom";
import email from "./assets/email.svg";
import location from "./assets/location.svg";
import phone from "./assets/phone.svg";
import { useBreakpoints } from "./ResponsiveBreapoints";

const Footer = () => {
  const navigate = useNavigate();
   const { IsXS} = useBreakpoints();
 
  const card = [
    {
      image: phone,
      name: "PHONE",
      description: '+1 (561) 699 - 0537'
    },
    {
      image: email,
      name: "EMAIL",
      description: "updates@jpcapital.finance",
    },
    {
      image: location,
      name: "LOCATION",
      description: "Sharjah City, Sharjah UAE 515000",
    },
  ];
  const links = [
    { text: "CONTACT US", link: "/contact-us" },
    { text: "PRIVACY POLICY", link: "/privacy-policy" },
    // { text: "TERMS OF USE", link: "/terms-of-use" },
    {text : "DISCLAIMER", link: "/disclaimer"}
  ];

  const handleLogoClick = () => {
    navigate('/');   
    window.scrollTo(0, 0);
  };

  const handleContactUs =()=>{
    navigate('/contact-us');
    window.scrollTo(0, 0); 
  }
  const handleClick = (link) => {
    if (link) {
      navigate(link);
      window.scrollTo(0, 0); 
    }
  };
  return (
    <Grid container justifyContent="center" className={styles.footerContainer}>
      <Grid
        size={{ xs: 11, sm: 11, md: 11, lg: 8, xl: 7, xxl:5 }}
        className={styles.footerSubContainer}
        ml={IsXS ? "" : 3}
      >
        <Grid container>
          <Grid size={12}>
            <Grid container spacing={3}>
              <Grid size={12}>
                <div
                  onClick={handleLogoClick}
                  style={{ cursor: "pointer" }}
                >
                  <Logo width="280" height="90" color="#ffffff" />
                </div>
              </Grid>
              <Grid size={12}>
                <Grid
                  container
                  // justifyContent="space-between"
                  // columnSpacing={6}
                  rowSpacing={4}
                >
                  <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                    <Grid container spacing={3}>
                      <Grid size={12}>
                        <Typography className={styles.footerHeading}>
                          BUILDING BRIDGES TO INVESTMENT SUCCESS
                        </Typography>
                      </Grid>
                      <Grid>
                        <Button
                          className={styles.footerButton}
                          onClick={handleContactUs}
                        >
                          Contact us
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid size={12}>
                <Grid container alignItems="center" rowSpacing={3}>
                  {card.map((data, index) => {
                    return (
                      <Grid
                        size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}
                        key={index}
                        sx={{ display: "flex", alignItems: "center" }}
                      >
                        <img
                          src={data.image}
                          alt={data.name}
                          width='50px'
                          height='50px'
                          style={{ marginRight: "10px", flexShrink: 0 }}
                        />
                        <Box sx={{ flex: 1 }}>
                          <Typography className={styles.footerUpName}>
                            {data.name}
                          </Typography>
                          <Typography className={styles.footerUpDescription}>
                            {data.description}
                          </Typography>
                        </Box>
                      </Grid>
                    );
                  })}
                </Grid>
              </Grid>
              <Grid size={12}>
                <Grid container rowSpacing={2}>
                  <Grid size={12}>
                    <Typography className={styles.footerLink}>LINKS</Typography>
                  </Grid>
                  <Grid>
                    <Grid container columnSpacing={1} rowSpacing={1}>
                      {links.map((item, index) => (
                        <React.Fragment key={index}>
                          <Grid item>
                            <Typography
                              className={styles.footerLinkText}
                              onClick={() => handleClick(item.link)}
                              style={{ cursor: "pointer" }}
                            >
                              {item.text}
                            </Typography>
                          </Grid>
                          {index < 2 && (
                            <Grid item>
                              <Typography className={styles.footerUpName}>
                                |
                              </Typography>
                            </Grid>
                          )}
                        </React.Fragment>
                      ))}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Footer;
